import React, { Component } from "react";
import { withRouter } from "react-router";
import { DataValue } from "../../../../CommonComponents/commonStyles";
import { getAccountData, isGeminiUser } from "../../../../utils/sessionUtil";
import { UserContainer, UserName, UserContributionDetails, UserDateDetails, ItemWrapper } from "../../styles";
import HyperLinkComponent from "../../../../CSR/CommonComponents/HyperLinkComponent/HyperLinkComponent";
import { ENTITY_OVERVIEW_URL } from "../../../../CSR/utils/geminiUrlMapper";
import PropTypes from 'prop-types';

class UserDetails extends Component {
 
  render() {
    const dob= this.props.profileData ? this.props.profileData.profileSummary.dateOfBirthStr: '';
    const name =  this.props.profileData ? this.props.profileData.profileSummary.name: '';
    return (
        <UserContainer data-test="UserDetailsBlock">
          { isGeminiUser() ? 
            <HyperLinkComponent className='username' to={`${ENTITY_OVERVIEW_URL}?partyId=${getAccountData().partyId}`} text={name}/> :
            <UserName className='myProfileUsername'>{name}</UserName>
          }
         

          <UserContributionDetails>
           <ItemWrapper>Date of Birth:</ItemWrapper>
            <UserDateDetails>{dob?<ItemWrapper>{dob}</ItemWrapper>: <DataValue> &mdash; </DataValue>}</UserDateDetails>
          </UserContributionDetails>
        </UserContainer>
     
    );
  }
}

UserDetails.propTypes = {
  profileData: PropTypes.object
}

export default withRouter(UserDetails);
